<template>
  <form @submit.prevent="submit">
    <Field
      label="Property/Measurement ID"
      @input="$v.resource.analytics_id.$touch()"
      @handleChange="handleChange"
      v-model="resource.analytics_id"
      helpText="As well as Google's Universal Analytics, we support the new Google Analytics 4"
      :error="analytics_idError"
      placeholder="UA-XXXXXXXXX-X or G-XXXXXXXXX"/>

    <div class="btn-save">
      <Btn :class="{'changes-made': changesMade}">Save Changes</Btn>
    </div>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'

import {errorMessages} from '@/lib/error_messages'

export default {
  name: 'SiteAnalyticsForm',

  mixins: [form],

  components: {
    Btn
  },

  computed: {
    ...errorMessages([
      'analytics_id'
    ])
  },

  validations: {
    resource: {
      analytics_id: {}
    }
  }
}
</script>
